module.exports = __webpack_public_path__ + "img/triangle2yellow.f299e03a.png";